import '../Styles/Logos.css';

export default function Logos(props) {
	const { language } = props;
	return (
		<div className="logos-wrapper">
			<a tabIndex={0} className="logo-greenpeace-link" aria-label={(language) ? language['aria:logo:greenpeace'] : 'Go to Greenpeace website'} rel="noreferrer" href="https://greenpeace.dk/" target="_blank">
				<div className="logo" role="none"></div>
			</a>
		</div>
	);
}
